export default __webpack_public_path__ + "static/media/img1.72876463.png";